// TODO: actually follow the redirect? (gathering this was a placeholder)
export const followRedirectStatus = response => response
